var map = {
	"./ar.json": [
		1925,
		925
	],
	"./bn.json": [
		4118,
		118
	],
	"./de.json": [
		1873,
		873
	],
	"./en.json": [
		8053
	],
	"./es.json": [
		1406,
		406
	],
	"./fa.json": [
		6807,
		807
	],
	"./fil.json": [
		8661,
		661
	],
	"./fr.json": [
		7222,
		222
	],
	"./hi.json": [
		9249,
		249
	],
	"./id.json": [
		3999,
		999
	],
	"./it.json": [
		8767,
		767
	],
	"./ja.json": [
		7083,
		83
	],
	"./km.json": [
		3598,
		598
	],
	"./ko.json": [
		3948,
		948
	],
	"./lo.json": [
		2407,
		407
	],
	"./ms.json": [
		1702,
		702
	],
	"./my.json": [
		9964,
		964
	],
	"./pt.json": [
		5034,
		34
	],
	"./ru.json": [
		8335,
		335
	],
	"./sw.json": [
		1100,
		100
	],
	"./th.json": [
		5074,
		74
	],
	"./tr.json": [
		2584,
		584
	],
	"./ur.json": [
		1785,
		785
	],
	"./vi.json": [
		5759,
		759
	],
	"./zh-Hans.json": [
		823,
		823
	],
	"./zh-Hant.json": [
		4138,
		138
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8631;
module.exports = webpackAsyncContext;